import { render } from "./Dashboard4.vue?vue&type=template&id=ee07ea78&scoped=true"
import script from "./Dashboard4.vue?vue&type=script&lang=js"
export * from "./Dashboard4.vue?vue&type=script&lang=js"

import "./Dashboard4.vue?vue&type=style&index=0&id=ee07ea78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee07ea78"]])

export default __exports__